import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
import _ from "lodash";

function obtenerInscripcionesPorColegio() {
  return dispatch => {
    rootRef
      .child("escuelas/verano2018/inscripciones")
      .once("value", snap => {
        const preins = snap.val();
        let prom = [];
        let numpre = {};

        _.forOwn(preins, (pres, idColegio) => {
          const numpres = Object.keys(pres).length;
          prom.push(
            rootRef.child(`detalles/colegios/${idColegio}`).once("value")
          );
          numpre = Object.assign({}, numpre, {
            [idColegio]: numpres
          });
        });

        Promise.all(prom)
          .then(resp => {
            let payload = [];
            resp.forEach(r =>
              payload.push(
                Object.assign({}, r.val(), {
                  num: numpre[r.key],
                  id: r.key
                })
              )
            );
            dispatch(actions.obtenerInscripcionesPorColegio(payload));
          })
          .catch(error => console.log(error));
      });
  };
}

function limpiarInscripcionesPorColegio() {
  return actions.limpiarInscripcionesPorColegio();
}

function obtenerInscripcionesDelColegio(idColegio) {
  return dispatch => {
    rootRef
      .child(`escuelas/verano2018/inscripciones/${idColegio}`)
      .once("value", snap => {
        const datos = snap.val();
        let payload = [];
        _.forOwn(datos, (valores, idInscripcion) => {
          payload.push(Object.assign({}, valores, { idInscripcion }));
        });
        dispatch(actions.obtenerInscripcionesDelColegio(payload));
      });
  };
}
function limpiarInscripcionesDelColegio() {
  return actions.limpiarInscripcionesDelColegio();
}

function obtenerDatosColegio(idColegio) {
  let prom = [
    rootRef.child(`detalles/colegios/${idColegio}`).once("value"),
    rootRef.child(`escuelas/verano2018/precios/${idColegio}`).once("value")
  ];

  return dispatch =>
    Promise.all(prom)
      .then(resp => {
        const id = resp[0].key;
        let payload = resp[0].val();
        payload.idColegio = id;

        payload.precios = resp[1].val();

        dispatch(actions.obtenerDatosColegio(payload));
      })
      .catch(error => error);
}

function limpiarDatosColegio() {
  return actions.limpiarDatosColegio();
}

function obtenerDatosInscripcion({ idColegio, idInscripcion }) {
  return dispatch =>
    rootRef
      .child(
        `escuelas/verano2018/inscripciones/${idColegio}/${idInscripcion}`
      )
      .on("value", snap =>
        dispatch(actions.obtenerDatosInscripcion(snap.val()))
      );
}

function limpiarDatosInscripcion() {
  return actions.limpiarDatosInscripcion();
}

function guardarCambiosInscripcion({ values, idColegio, idInscripcion }) {
  return dispatch => {
    let insert = {};
    values.nombre = values.nombre.trim().toUpperCase();
    values.apellido1 = values.apellido1.trim().toUpperCase();
    insert[
      `escuelas/verano2018/inscripciones/${idColegio}/${idInscripcion}`
    ] = values;

    rootRef.update(insert, () => {
      const payload = {
        status: true,
        message: "Se han guardado los cambios",
        resguardo: idInscripcion
      };
      dispatch(actions.dataSaved(payload));
    });
  };
}

function resetSavedData() {
  return actions.resetDataSaved();
}

function aplicarFiltros(filtros) {
  return actions.aplicarFiltros(filtros);
}

function resetFiltros() {
  return actions.resetFiltros();
}

function cambiarFormaDePago({ idColegio, idInscripcion, formaDePago }) {
  const inscripciones = "escuelas/verano2018/inscripciones";
  let insert = {};
  insert[
    `${inscripciones}/${idColegio}/${idInscripcion}/formaDePago`
  ] = formaDePago;
  return dispatch =>
    rootRef.update(insert, () => {
      const payload = {
        status: true,
        message: "Se ha cambiado la forma de pago",
        resguardo: idInscripcion
      };
      dispatch(actions.dataSaved(payload));
    });
}

function borrarInscripcion({ idColegio, idInscripcion }) {
  const ruta = "escuelas/verano2018/inscripciones";
  return dispatch => {
    let insert = {};
    insert[`${ruta}/${idColegio}/${idInscripcion}`] = null;
    rootRef.update(insert, () => {
      const payload = {
        status: true,
        message: "Se ha eliminado el registro",
        resguardo: idInscripcion
      };
      dispatch(actions.dataSaved(payload));
    });
  };
}

/*---*/
export {
  obtenerInscripcionesPorColegio,
  limpiarInscripcionesPorColegio,
  obtenerInscripcionesDelColegio,
  limpiarInscripcionesDelColegio,
  obtenerDatosColegio,
  limpiarDatosColegio,
  obtenerDatosInscripcion,
  limpiarDatosInscripcion,
  guardarCambiosInscripcion,
  resetSavedData,
  aplicarFiltros,
  resetFiltros,
  cambiarFormaDePago,
  borrarInscripcion
};



// WEBPACK FOOTER //
// ./src/ducks/confirmadas/operations.js